module.exports = __webpack_public_path__ + "static/media/IMG_0415.ea3818dd.HEIC";